import React from 'react';
import Qrcode from './Qrcode'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Qrcode />
      </header>
    </div>
  );
}

export default App;
